import { z } from 'zod';

export const cohortResDto = z.object({
  id: z.string(),
  startDate: z.coerce.date(),
  createdAt: z.coerce.date(),
  onboardingEndDate: z.coerce.date(),
});
export type CohortResDto = z.infer<typeof cohortResDto>;
